const eventColors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  create: {
    primary: '#219653',
    secondary: '#a6d5ba66',
  },
  accept: {
    primary: '#56CCF2',
    secondary: '#bbebfa66',
  },
  schedule: {
    primary: '#2D9CDB',
    secondary: '#abd7f166',
  },
  start: {
    primary: '#F37200',
    secondary: '#fac79966',
  },
  pause: {
    primary: '#FF9500',
    secondary: '#ffd59966',
  },
  finish: {
    primary: '#adbf3a',
    secondary: '#adbf3a33',
  },
  suspend: {
    primary: '#8F00FF',
    secondary: '#d299ff66',
  },
  reSchedule: {
    primary: '#FFC700',
    secondary: '#ffe99966',
  },
  cancel: {
    primary: '#EF5533',
    secondary: '#f9bbad66',
  },
  onWay: {
    primary: '#1BC4BA',
    secondary: '#a4e7e366',
  },
  reject: {
    primary: '#FF1D53',
    secondary: '#ffa4ba66',
  },
  setContractor: {
    primary: '#7A66FF',
    secondary: '#cac2ff66',
  },
  close: {
    primary: '#3f23fb',
    secondary: '#bfcafb66',
  },
  postponed: {
    primary: '#B3917B',
    secondary: '#edc1a3',
  },
  Presupuestada: {
    primary: '#E788BB',
    secondary: '#e788bb66',
  },
};

const actions: any = {
  edit: {
    label:
      '<i class="material-icons mat-icon color-ind-orange" title="Editar programación">edit</i>',
    code: 'Edit',
  },
  delete: {
    label:
      '<i class="material-icons mat-icon color-ind-red" title="Cancelar programación">delete</i>',
    code: 'Delete',
  },
  info: {
    label:
      '<i class="material-icons mat-icon color-ind-primary cursor-help" title="TITLE">info</i>',
    code: 'Info',
  },
  view: {
    code: 'View',
  },
};

export { eventColors, actions };
